import React, {useEffect, useState} from 'react';
import './TableDataChanger.scss';
import _axios from "../../../../../httpService";
import {toast} from "react-toastify";
import ModalAddAndEdit from "../ModalDataChanger(Dyna)/ModalAddAndEdit";
import ModalDeleteTF from "../ModalDataChanger(Dyna)/ModalDeleteTF";
import Select from "react-select";
import Modal, {ModalBody, ModalHeader} from "../../../../Modal";
import Form from "../../../../Form";
import utilsFunction from "../../../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../../../utils/exportCSVFile";

const TableDataChangerVTwo = ({
                                initialData,
                                setComponentData,
                                loadTable,
                                currentRowData,
                                setFilterData,
                                setInitialDataManage,
                              }) => {
  debugger
  const prefixUrl = localStorage.getItem("apiUrl");
  const [optionLabel, setOptionLabel] = useState({
    one: "انتخاب کنید",
    two: "انتخاب کنید",
    three: "انتخاب کنید",
  });
  const [optionValue, setOptionValue] = useState("");
  const [optionValueTwo, setOptionValueTwo] = useState("");
  const [optionValueThree, setOptionValueThree] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modeModal, setModeModal] = useState("ADD")
  const [editModeData, setEditModeData] = useState({groupId: []})
  const [currentId, setCurrentId] = useState("");
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false)
  const [openModalEditTypeOne, setOpenModalEditTypeOne] = useState(false)

  function addDataModalCallbackHandler({isOpen}) {
    setOpenModalEditTypeOne(isOpen);
  }

  useEffect(() => {
    setComponentData({column: initialData.accountsList.column, data: initialData.accountsList.data});
  }, [initialData])

  const addModalOpen = () => {
    _axios.get(prefixUrl + "/accountingGroups/?request=accountGroups")
      .then((res) => {
        if (res.data.status) {
          setModeModal("ADD")
          setIsOpenModal(true)
          setModalData(res.data.data)
        } else {
          toast.error("مشکلی در دریافت داده رخ داد.");
        }
      })
  };

  const editModalOpen = () => {

    if (Object.keys(currentRowData).length > 0) {
      if (currentRowData?.editType === "2") {
        _axios.get(prefixUrl + "/accountingAccounts/?request=accountData&id=" + currentRowData.id)
          .then((res) => {
            if (res.data.status) {
              setModeModal("EDIT")
              setIsOpenModal(true);
              setModalData(res.data.data.groups)
              setEditModeData(res.data.data)
              setCurrentId(currentRowData.id)
            }
          });
      } else {
        editModalHandlerTypeOne(currentRowData.destination, currentRowData.mainId)
        setModalData({type: "edit"});
      }
    } else {
      toast("لطفا یک سطر را انتخاب کنید");
    }
  }

  const editModalHandlerTypeOne = () => {
    setOpenModalEditTypeOne(true)
  };

  const filterSelectHandler = () => {
    setOptionLabel({
      one: "انتخاب کنید",
      two: "انتخاب کنید",
      three: "انتخاب کنید",
    })
    setOptionValue("")
    setOptionValueTwo("")
    setOptionValueThree("")
    setFilterData({
      hasFilter: false,
      level: 1,
      value: 10,
      label: "10 - موجودی نقد و بانک"
    })
  }

  const customStyles = {
    option: (base) => ({
      ...base,
      color: "#1e2022",
      backgroundColor: "white",
    }),
  };

  const letGoXLS = () => {

    const printColumn = [
      {title: 'کد تفصیل', field: 'id'},
      {title: 'عنوان تفصیل', field: 'accountTitle'},
      {title: 'گروه تفصیل', field: 'groupName'}
    ]

    let printData = []
    initialData.accountsList.data.forEach((v) =>{
      printData.push({id:v.id , accountTitle:v.accountTitle , groupName:v.groupName})
    })

    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const fileName = "جدول تفصیلی ها " + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(printColumn, printData)
    //exportCSVFile(normalizeData, fileName, "")
    exportXLSXFile(normalizeData, fileName, "")

  }

  return (
    <>
      {isOpenModal &&
        <ModalAddAndEdit modeModal={modeModal}
                         editModeData={editModeData}
                         onClose={() => setIsOpenModal(false)}
                         currentId={currentId}
                         setInitialDataManage={setInitialDataManage}
                         modalData={modalData}/>}
      {isOpenModalDelete &&
        <ModalDeleteTF setInitialDataManage={setInitialDataManage}
                       onClose={() => setIsOpenModalDelete(false)}
                       currentRowData={currentRowData}/>
      }

      <Modal
        isOpen={openModalEditTypeOne}
        modalCallback={addDataModalCallbackHandler}
      >
        <ModalHeader title={"ویرایش"}/>
        <ModalBody>
          <Form id={currentRowData.destination}
                primaryKey={
                  currentRowData.mainId
                }/>
        </ModalBody>
      </Modal>

      <div className="data-changer-v-two">

        <div className="buttons-side">
          <div className="button-styl" onClick={addModalOpen}>
            <p>تفصیل جدید</p>
          </div>

          <div className="button-styl" onClick={editModalOpen}>
            <p>ویرایش تفصیل</p>
          </div>

          <div className="button-styl" onClick={() => {
            currentRowData.id !== undefined ? setIsOpenModalDelete(true) : toast("لطفا یک سطر را انتخاب کنید")
          }}>
            <p>حذف تفصیل</p>
          </div>

          <div className="button-styl" onClick={letGoXLS}>
            <p>دانلود اکسل</p>
          </div>

          {/*<GetBillDataInTableDataChanger selectedRow={currentRowData}/>*/}
          {/*for run this line must change primaryKey to A4 in OpenModalSelectBillItemToPrint.jsx */}

        </div>

        <div className="row-filter">

          <div className="filter-side">

            <div className="single-filter">
              <label>کد گروه</label>
              <div className="select-filter">
                <Select options={initialData?.level_0}
                        styles={customStyles}
                        isDisabled={!loadTable}
                        value={{value: optionValue, label: optionLabel.one}}
                        onChange={(e) => {
                          setFilterData({hasFilter: true, level: 0, value: e.value, label: e.label})
                          setOptionValue(e.value)
                          setOptionLabel({...optionLabel, one: e.label})
                        }}/>
              </div>
            </div>

            <div className="single-filter">
              <label>کد کل</label>
              <div className="select-filter">
                <Select options={initialData?.level_1}
                        styles={customStyles}
                        isDisabled={!loadTable}
                        value={{value: optionValueTwo, label: optionLabel.two}}
                        onChange={(e) => {
                          setFilterData({hasFilter: true, level: 1, value: e.value, label: e.label})
                          setOptionValueTwo(e.value)
                          setOptionLabel({...optionLabel, two: e.label})
                        }}/>
              </div>
            </div>

            <div className="single-filter">
              <label>کد معین</label>
              <div className="select-filter">
                <Select options={initialData?.level_2}
                        styles={customStyles}
                        isDisabled={!loadTable}
                        value={{value: optionValueThree, label: optionLabel.three}}
                        onChange={(e) => {
                          setFilterData({hasFilter: true, level: 2, value: e.value, label: e.label})
                          setOptionValueThree(e.value)
                          setOptionLabel({...optionLabel, three: e.label})
                        }}/>
              </div>
            </div>

          </div>

          <button onClick={filterSelectHandler} className="delete-filter">حذف فیلتر</button>
        </div>

      </div>
    </>
  );
};

export default TableDataChangerVTwo;